import { ButtonBase, Collapse } from '@mui/material';
import SvgArrowDown from 'assets/pricing/arrow-down.inline.svg';
import SvgArrowUp from 'assets/pricing/arrow-up.inline.svg';
import React, { useRef } from 'react';
import tw from 'twin.macro';

export default function Card({ isOpen, isGreen, title, description, collapsedSize, onOpen, onClose, ...props }) {
	const refCard = useRef();

	const handleToggleCard = event => {
		if (isOpen) {
			refCard.current.scrollIntoView({ behavior: 'smooth' });
			setTimeout(() => {
				onClose(event);
			}, 300);
		} else {
			onOpen(event);
		}
	};

	return (
		<div tw="h-full relative" {...props}>
			<div ref={refCard} className="absolute top-0 -mt-20"/>

			<div
				style={{ maxWidth: '25rem' }}
				css={[
					isGreen ? tw`border-green-7` : tw`border-grey-E`,
					tw`flex flex-col justify-between sm:h-full sm:w-120 lg:w-150 xl:w-180 relative border-2 rounded-10 bg-light mx-auto`
				]}
			>
				<div>
					<div
						style={{ marginTop: '-0.25rem' }}
						css={[
							isGreen ? tw`from-green-7 to-green-3` : tw`from-silver-0 to-silver-1`,
							tw`absolute ml-07 xl:ml-10 top-0 w-50 h-03 xl:h-04 rounded-10 bg-gradient-to-r`
						]}
					/>

					<div className="pb-30 xs:pb-18 sm:pb-24 pt-10 sm:py-18 px-10">
						<p className="text-14 font-bold mt-07 mb-10">{title}</p>
						<Collapse tw='mb-05' in={isOpen} collapsedSize={collapsedSize}>
							<p className="text-grey-6">{description}</p>
						</Collapse>
					</div>
				</div>

				<div style={{ marginBottom: '-27px', marginLeft: '-27px' }} className="absolute bottom-0 left-50/100">
					<ButtonBase tw="rounded-full" onClick={handleToggleCard}>
						{isOpen ? <SvgArrowUp/> : <SvgArrowDown/>}
					</ButtonBase>
				</div>
			</div>
		</div>
	);
}

Card.defaultProps = {
	collapsedSize: '21.5rem'
};
